import { createSlice } from "@reduxjs/toolkit";

const initialPricingState = {
  pricing: null,
  loading: false,
  error: null,
};

const pricingSlice = createSlice({
  name: "pricing",
  initialState: initialPricingState,
  reducers: {
    setPricing(state, action) {
      state.pricing = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const pricingActions = pricingSlice.actions;
export default pricingSlice.reducer;

